<template>
  <div>
    <div class="input" @click="dialogVisible = true">
      <div class="icon">
        <el-tooltip :content="newValue" placement="top">
          <i :class="newValue"></i>
        </el-tooltip>
      </div>
    </div>
    <el-dialog title="选择图标" :visible.sync="dialogVisible" width="50%">
      <span class="list" v-for="(item, index) in iconList" :key="index">
        <div class="item" @click="clickItem(item)">
          <div class="icon">
            <el-tooltip :content="item" placement="top">
              <i :class="item"></i>
            </el-tooltip>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { formMixin } from "vue-ele-form";
import { iconList } from "../icon.js";
export default {
  name: "selectIcon", // name 属性必须填写, 在使用时, 需要和这里定义的 name 一致
  mixins: [formMixin], // 必须引入mixin
  props: {
    // value 是传递过来的值
    value: String,
    // desc是此组件的描述, 结构为
    // { style: {}, class: {}, on: {}, attrs: {} }
    desc: {
      type: Object,
      default() {
        return {
          action: "",
          fileList: [
            {
              name: "food.jpeg",
              url:
                "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
            },
            {
              name: "food2.jpeg",
              url:
                "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      // 用于v-model绑定, 因为 v-model无法绑定props值
      newValue: this.value,
      icon: "",
      iconList: iconList,
      dialogVisible: false
    };
  },
  watch: {
    newValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    clickItem(e) {
      this.newValue = e;
      this.dialogVisible = false;
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    LookPhoto() {},
    Submit() {}
  }
};
</script>
<style lang="scss">
.input {
  width: 70px;
  height: 31px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  border-right: 5px;
  border: 1px solid #dcdfe6;
  .icon {
    font-size: 25px;
  }
}
.list {
  display: inline-flex;
  .item {
    background-color: #f2f6fc;
    margin: 5px;
    width: 60px;
    .icon {
      text-align: center;
      font-size: 40px;
    }
  }
}
</style>
